import _ from 'lodash'
import { DateTime } from 'luxon'
import moment from 'moment'
import UserGroupsMixin from './user-groups-mixin'
const randomColor = require('randomcolor')

export default {
    data() {
        return {
            currentChannel: '',
            currentWANotificationId: '',
            currentUsers: [],
            messageList: [],
        }
    },

    computed: {
        participants() {
            return this.currentUsers.map(user => {
                let id = user.id
                if (user.id === this.$auth.user().UserID) {
                    id = 'me'
                }
                const res = {
                    id,
                    name: user.name,
                    imageUrl: '/images/icon/chat/chat-user.png',
                    color: randomColor({ luminosity: 'dark', count: 27 }),
                }
                return res
            })
        },

        sortedMessages() {
            const sorted = this.messageList.sort(
                (a, b) => moment(a.CreatedAt) - moment(b.CreatedAt)
            )
            return sorted
        },

        isValidParticipant() {
            const filtered = this.currentUsers.filter(
                it => it.id === this.$auth.user().UserID
            )
            return filtered && filtered.length > 0
        },
    },

    mixins: [UserGroupsMixin],

    methods: {
        async createChannel(notification) {
            let channelName = ''
            let users = [this.$auth.user().UserID]
            if (notification.RecipientUserGroupID) {
                const userGroup = await this.fetchUserGroupById(
                    notification.RecipientUserGroupID
                )
                if (userGroup) {
                    channelName = userGroup.GroupName
                    users.push(...userGroup.Users.map(it => it.UserID))
                }
            } else {
                users.push(notification.RecipientUserID)
            }

            const body = {
                ChannelName: channelName,
                CustomType: 'CHAT',
                Data: notification.WANotificationID,
                Status: true,
                CreatedAt: moment()
                    .utc()
                    .format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
                Users: _.uniq(users),
            }

            const { data } = await this.$http.post(`Channel`, body)
            return data
        },

        async fetchChannel(channelId, userId) {
            const { data } = await this.$http.get(`Channel/${channelId}`)
            this.currentChannel = data.ChannelId
            this.currentWANotificationId = data.Data
            this.currentUsers = data.Users.map(it => {
                return {
                    id: it.UserID,
                    name: it.FirstName + ' ' + it.LastName,
                }
            })
        },

        async fetchMessages(channelId, userId) {
            const body = {
                CurrentPage: 1,
                PageSize: 10,
                ChannelId: channelId,
            }
            const { data } = await this.$http.post(`Message/Channel`, body)
            if (data && data.responseData) {
                this.messageList.push(
                    ...data.responseData.map(item => {
                        const message = {
                            type: 'text',
                            author:
                                item.Sender.UserID === userId
                                    ? 'me'
                                    : item.Sender.UserID,
                            data: { text: item.Message },
                            OriginalCreatedAt: item.CreatedAt,
                            CreatedAt: moment(
                                DateTime.fromISO(item.CreatedAt, {
                                    zone: 'utc',
                                }).toJSDate()
                            ).format('YYYY-MM-DD HH:mm:ss'),
                        }
                        return message
                    })
                )
            }
        },

        async fetchPreviousMessages(channelId, userId) {
            if (this.sortedMessages.length > 0) {
                const body = {
                    Count: 10,
                    DateTimeStamp: this.sortedMessages[0].OriginalCreatedAt,
                }

                const { data } = await this.$http.post(
                    `Channel/${channelId}/Messages/Previous`,
                    body
                )
                if (data && data.length > 0) {
                    this.messageList.push(
                        ...data.map(item => {
                            const message = {
                                type: 'text',
                                author:
                                    item.Sender.UserID === userId
                                        ? 'me'
                                        : item.Sender.UserID,
                                data: { text: item.Message },
                                OriginalCreatedAt: item.CreatedAt,
                                CreatedAt: moment(
                                    DateTime.fromISO(item.CreatedAt, {
                                        zone: 'utc',
                                    }).toJSDate()
                                ).format('YYYY-MM-DD HH:mm:ss'),
                            }
                            return message
                        })
                    )
                } else {
                    return false
                }
            }
            return true
        },

        async fetchUserMessages(currentPage, customType) {
            let body = {
                CurrentPage: currentPage,
                PageSize: 10,
            }
            if (customType !== 'ALL') {
                body.CustomType = customType
            }

            const { data } = await this.$http.post(`Message/User`, body)
            return data && data.responseData ? data.responseData : []
        },

        readMessages(channelId) {
            this.$http.post(`/Message/Channel/${channelId}/Read`)
        },

        readNotifications() {
            this.$http.post(`/Message/User/Read`)
        },
    },
}
